import { useContext, useEffect } from "react"
import GeneralContext from '../../context/GeneralContext/GeneralContext';
import api from "../../services/api";
import SL_Button from '../../components/buttons/Button'
import { displayMessage } from "../../services/helper";
import { Form, Input, Typography } from "antd";
import styles from "../../services/styles";
const { tc2 } = styles


export function Config() {
    
    const {
        setShowLoading,
        mobile_mode
    } = useContext(GeneralContext)

    const [form] = Form.useForm()
    
    useEffect(() => {
        getRules()
    }, [])
    
    async function getRules() {
        setShowLoading(true)
        try {
            const { data } = await api.config.getRuleConfig()
            const rule_for_time_bar = data[0]?.rule_for_time_bar ?? ''
            const rule_for_sections = data[0]?.rule_for_sections ?? ''
            const rule_for_lenguage = data[0]?.rule_for_lenguage ?? ''
            form.setFieldsValue({ rule_for_time_bar, rule_for_sections, rule_for_lenguage })
        } catch (error) {
            console.log(error)
        } finally {
            setShowLoading(false)
        }
    }

    async function onFinish(values) {
        setShowLoading(true)
        try {
            values.rule_for_time_bar = values.rule_for_time_bar ? values.rule_for_time_bar.replace(/\n\s*\n/g, '\n') : null
            values.rule_for_sections = values.rule_for_sections ? values.rule_for_sections.replace(/\n\s*\n/g, '\n') : null
            values.rule_for_lenguage = values.rule_for_lenguage ? values.rule_for_lenguage.replace(/\n\s*\n/g, '\n') : null
            await api.config.updateRuleConfig(values)
            await getRules()
            alert(displayMessage('SUCCESS_UPDATE_CONFIG'), 'success', displayMessage('SUCCESS'))
        } catch (error) {
            console.log(error)
        } finally {
            setShowLoading(false)
        }
    }


    return (
        <div className={`flex w-full flex-col`}>
            <div className={`flex flex-1 justify-between p-2 bg-appian-blue gap-1 ${mobile_mode ? `flex-col` : `flex-row`} `}>
                <span className='self-center text-white flex-1 text-center font-medium'>{displayMessage('RULE_CONFIG_TEXT')}</span>         
            </div>
            <div className="h-full w-full">
                <Form
                    form={form}
                    className="flex flex-col mt-8"
                    onFinish={onFinish}
                    layout={'vertical'}
                >
                    <div>
                        <Typography.Title level={5}>{displayMessage('RULE_CONFIG_TITLE')}:</Typography.Title>
                    </div>
                    <div className={`flex flex-1 w-full ${mobile_mode ? 'flex-col' : 'flex-row'} justify-between items-center`}>
                        <Form.Item
                            shouldUpdate
                            name="rule_for_time_bar"
                            className={`w-full flex`}
                        >
                                <Input.TextArea className={`w-full`} rows={10}/>
                        </Form.Item>
                    </div>
                    <div>
                        <Typography.Title level={5}>{displayMessage('SECTIONS_RULE_CONFIG_TITLE')}:</Typography.Title>
                    </div>
                    <div className={`flex flex-1 w-full ${mobile_mode ? 'flex-col' : 'flex-row'} justify-between items-center`}>
                        <Form.Item
                            shouldUpdate
                            name="rule_for_sections"
                            className={`w-full flex`}
                        >
                                <Input.TextArea className={`w-full`} rows={7} placeholder={displayMessage("SECTIONS_RULE_CONFIG_TITLE_EXEMPLO")}/>
                        </Form.Item>
                    </div>
                    <div>
                        <Typography.Title level={5}>{displayMessage('SECTIONS_RULE_LANGUAGE_CONFIG_TITLE')}:</Typography.Title>
                    </div>
                    <div className={`flex flex-1 w-full ${mobile_mode ? 'flex-col' : 'flex-row'} justify-between items-center`}>
                        <Form.Item
                            shouldUpdate
                            name="rule_for_lenguage"
                            className={`w-full flex`}
                        >
                                <Input.TextArea className={`w-full`} rows={4} placeholder={displayMessage("SECTIONS_RULE_CONFIG_LANGUAGE_EXEMPLO")}/>
                        </Form.Item>
                    </div>
                    <div className={`flex flex-1 w-full items-start justify-start`}>
                        <SL_Button
                            type='primary'
                            className='w-[150px]'
                            style={{ backgroundColor: tc2 }}
                            onClick={() => form.submit()}
                        >
                            {displayMessage('SAVE')}
                        </SL_Button>
                    </div>
                </Form>
            </div>
        </div>
    )
}